import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_BRAND_TERRITORY_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-territories/index.ts',
  name: 'Get Brand Territory',
  message: 'Failed to fetch brand territory data',
}
